import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLang, translations } from '../i18n';
import LanguageDropdownCompact from '../components/LanguageDropdownCompact';
import './Login.css';

const API_FORGOT_PASSWORD_2 = process.env.REACT_APP_API_USERS + "/forgot-password-2" || '';

const ForgotPassword2: React.FC = () => {
  const { lang } = useLang();
  const t = translations[lang];
  const navigate = useNavigate();
  const location = useLocation();

  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const email = location.state?.email;

  // Rediriger vers l'étape 1 si pas d'email
  useEffect(() => {
    if (!email) {
      navigate('/forgot-password-1');
    }
  }, [email, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(API_FORGOT_PASSWORD_2, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code })
      });

      if (!response.ok) {
        throw new Error('Code invalide');
      }

      const data = await response.json();

      // Vérifier si le code est valide
      if (data.message === 'ok' && data.token) {
        // Rediriger vers l'étape 3 avec le token
        navigate('/forgot-password-3', { state: { token: data.token, email } });
      } else {
        setError(t.forgotPasswordCodeError);
      }

    } catch (err) {
      setError(t.forgotPasswordCodeError);
    } finally {
      setLoading(false);
    }
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ''); // Uniquement des chiffres
    if (value.length <= 6) {
      setCode(value);
    }
  };

  return (
    <div className="login-page">
      <form className="login-form" onSubmit={handleSubmit}>
        <div style={{display:'flex',justifyContent:'center',marginBottom:24,position:'relative'}}>
          <img src={process.env.PUBLIC_URL + '/recat-logo-1024.png'} alt="Logo" style={{height:80}} />
          <div style={{position:'absolute',right:0,top:0}}>
            <LanguageDropdownCompact />
          </div>
        </div>
        
        <h2>{t.forgotPasswordCodeTitle}</h2>
        <p style={{ margin: '0 0 8px 0', color: '#666', textAlign: 'center', fontSize: '0.95rem' }}>
          {t.forgotPasswordCodeSent} <strong>{email}</strong>
        </p>
        <p style={{ margin: '0 0 15px 0', color: '#999', textAlign: 'center', fontSize: '0.85rem', fontStyle: 'italic' }}>
          {t.forgotPasswordCodeSpam}
        </p>

        <input
          type="text"
          value={code}
          onChange={handleCodeChange}
          placeholder={t.forgotPasswordCodePlaceholder}
          required
          disabled={loading}
          maxLength={6}
          style={{ 
            fontSize: '24px', 
            letterSpacing: '8px', 
            textAlign: 'center',
            fontFamily: 'monospace'
          }}
        />

        {error && <div className="login-error">{error}</div>}

        <button type="submit" disabled={loading || code.length !== 6}>
          {loading ? t.forgotPasswordCodeLoading : t.forgotPasswordCodeBtn}
        </button>

        <div style={{ textAlign: 'center', marginTop: '10px' }}>
          <a href="/forgot-password-1" style={{ color: '#2aa04aff', textDecoration: 'underline', fontSize: '0.95rem' }}>
            Retour
          </a>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword2;
